import React from 'react'

import type { IconProps } from './types'

const Soya: React.FC<IconProps> = ({
  size = 40,
  color = '#EC1B2E',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.3893 23.4501C16.4093 23.1201 17.3093 22.5601 18.0693 21.8C18.8293 21.04 19.3793 20.1401 19.7193 19.1301C20.0693 18.0701 19.1393 17.6801 18.9493 17.6201C18.8993 17.6 18.6993 17.54 18.4393 17.54C18.0593 17.54 17.5593 17.6801 17.3093 18.3701L17.1193 18.9C16.7893 19.8101 16.0793 20.52 15.1693 20.85L14.6293 21.05C13.4993 21.46 13.8393 22.5601 13.8893 22.6901C13.9493 22.8801 14.3393 23.8 15.3893 23.4501Z"
        fill={color}
      />
      <path
        d="M7.7002 13.0601V29.0001C7.7002 29.55 8.15015 30.0001 8.7002 30.0001H24.9001C25.4502 30.0001 25.9001 29.55 25.9001 29.0001V13.0601H7.7002ZM13.9502 19.17L14.4902 18.97C14.8401 18.84 15.1102 18.5701 15.2402 18.22L15.4402 17.6801C16.1602 15.7001 18.0802 15.2001 19.6102 15.73C21.1002 16.2501 22.2701 17.8 21.6202 19.7501C21.1802 21.0601 20.4702 22.23 19.4802 23.21C18.5002 24.2001 17.3302 24.92 16.0201 25.35C15.6402 25.48 15.2802 25.53 14.9302 25.53C13.5002 25.53 12.4102 24.54 12.0002 23.34C11.4702 21.8101 11.9702 19.8901 13.9502 19.17Z"
        fill={color}
      />
      <path
        d="M25.5796 11.0601L24.1396 7.31006H9.45953L8.01953 11.0601H25.5796ZM16.8096 8.19006H16.8196C17.3696 8.19006 17.8196 8.64008 17.8196 9.19006C17.8196 9.74005 17.3696 10.1901 16.8196 10.1901C16.2695 10.1901 15.8196 9.74005 15.8196 9.19006C15.8196 8.64008 16.2596 8.19006 16.8096 8.19006Z"
        fill={color}
      />
      <path
        d="M23.6902 5.31V3C23.6902 2.45001 23.2402 2 22.6902 2H10.9102C10.3602 2 9.91016 2.45001 9.91016 3V5.31H23.6902Z"
        fill={color}
      />
    </svg>
  )
}

export default Soya
